import * as React from 'react';
import {Component, inject, observer, deps, StatefulComponent} from '../lib/component';
import {classes, style} from 'typestyle';
import {SearchToolbar} from '../components/search/toolbar';
import {ConnectedSearchResults} from '../components/search/results';
import SearchFilters from '../components/search/filters';
import {constantHeaderHeight} from '../theme/constant';
import {transitionQuickEase} from '../theme/transition';
import {ConnectedSearchSummary} from '../components/search/summary';
import MainWrapper from '../components/main-wrapper';
import {Tag} from '../types/graphql';

export interface SearchPageProps {

}

type State = {
  suggestions: Tag[]
}

@inject(deps) @observer
export class SearchPage extends StatefulComponent<SearchPageProps, State> {
  private $input : HTMLInputElement;

  state = {
    suggestions: []
  };

  render() {
    const { showSignUpCTA } = this.props.model.ui;
    const {filterI18n, loading, apiState} = this.props.model.page.search;

    const className = classes(
      SearchPage.styles.container,
      showSignUpCTA && SearchPage.styles.containerShunted
    );

    return (
      <MainWrapper className={className}>
        <SearchToolbar suggestions={this.state.suggestions} inputRef={(element) => { this.$input = element }}/>
        <ConnectedSearchSummary query={apiState.query} onSuggestions={this.handleSuggestions}/>
        <SearchFilters i18n={filterI18n}/>
        {!loading && (
          <ConnectedSearchResults {...apiState} onClearClick={this.resetSearch}/>
        )}
      </MainWrapper>
    )
  }

  resetSearch = () => {
      this.props.controller.page.search.refineQuery();

      if (this.$input) {
        this.$input.focus();
      }
  };

  handleSuggestions = (suggestions: Tag[]) => this.setState({suggestions});

  static styles = {
    container: style({
      margin: 0,
      position: 'relative',
      padding: `${constantHeaderHeight} 0 0 0`,
      transition: `padding ${transitionQuickEase}`,
      minHeight: `calc(100vh - (3 * ${constantHeaderHeight}))`,
    }),
    containerShunted: style({
      padding: `calc(2 * ${constantHeaderHeight}) 0 0 0`
    })
  }
}